import React, { useContext } from 'react'
import alertContext from 'stateManagement/alert/AlertContext'
import {
    ALERT_ERROR,
    ALERT_SUCCESS,
    ALERT_WARNING
} from 'stateManagement/types/General/alertActionType';
import notification from 'utils/Notification/notification'

const Alert = () => {
    const context = useContext(alertContext);
    const { alerts } = context;

    return (
        alerts.length > 0 && alerts.map((alert, index) => {

            if (alert.type == ALERT_SUCCESS) {
                if (alert.shown == false) {
                    alert.shown = true;
                    return notification({ timeout: alert.timeout }).success(alert.message)
                }
            } else if (alert.type == ALERT_ERROR) {
                if (alert.shown == false) {
                    alert.shown = true;
                    notification({ timeout: alert.timeout }).failure(alert.message)
                }
            } else if (alert.type == ALERT_WARNING) {
                if (alert.shown == false) {
                    alert.shown = true;
                    notification({ timeout: alert.timeout }).warning(alert.message)
                }
            } else {
                if (alert.shown == false) {
                    alert.shown = true;
                    notification({ timeout: alert.timeout }).info(alert.message)
                }
            }

        })

        // alert.type == ALERT_SUCCESS ? 
        //     notification({ timeout: alert.timeout }).success(alert.message)
        //     : (alert.type == ALERT_ERROR ?
        //         notification({ timeout: alert.timeout }).failure(alert.message)
        //         : (alert.type == ALERT_WARNING ?
        //             notification({ timeout: alert.timeout }).warning(alert.message) :
        //             notification({ timeout: alert.timeout }).info(alert.message)))
    )
}

export default Alert;

